<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UXgsqF/tc-custom/9781504027908.jpg?1704717788478" alt="This image is the cover for the book Because We Are"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Because We Are
      </h1>
      <p class="bookDescription body article font2">
        <b>Emma’s dreams of popularity and academic success go up in smoke when she’s transferred to a less prestigious high school</b><br/><br/> Twelfth grader Emma Walsh is one of the lucky few African Americans at exclusive Marlborough High School. She is the only black student on the student council, and she’s just been elected to the National Honor Society. Now, the Golden Slippers will invite her to participate in their annual debutante ball. Graduation will be followed by a scholarship to a major university, then a celebrated career as a doctor. Her future couldn’t be brighter.<br/>  <br/> Until an uncalled-for outburst gets her transferred to the all-black Manning High School in the district where she lives. Emma fears she won’t fit in with the other students who are less fortunate than she. Her only friend is shy Allan Page, a senior on a free busing program who could have chosen any high school—and picked Manning. As Emma becomes caught up in life at her new school, her old life feels farther and farther away. Does she really want to be a debutante? Who is she trying to impress? Her successful physician father? Her boyfriend? What about herself?<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mildred Pitts Walter
      </h2>
      
      <p class="authorDescription body article">Mildred Pitts Walter (b. 1922) grew up in Louisiana. She was the first member of her family to attend college, and then became a teacher and civil rights activist. As a book reviewer for the <I>Los Angeles Times</I>, Walter noticed that there were few books about African Americans, especially for children, and decided to write them herself. She has written over twenty books for children, and has been heralded for her compelling portraits of African American family life. Walter was awarded the Coretta Scott King Award for <I>Justin and the Best Biscuits in the World</I>; <I>Because We Are</I> and <I>Trouble&#39;s Child</I> are Coretta Scott King Honor Books. Walter now lives in Denver, where she was inducted into the Colorado Women&rsquo;s Hall of Fame in 1996.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52706412